import { render } from "./CharlaHeader.vue?vue&type=template&id=0dde209a&scoped=true"
import script from "./CharlaHeader.vue?vue&type=script&lang=js"
export * from "./CharlaHeader.vue?vue&type=script&lang=js"

import "./CharlaHeader.vue?vue&type=style&index=0&id=0dde209a&scoped=true&lang=sass"
import "./CharlaHeader.vue?vue&type=style&index=1&id=0dde209a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dde209a"]])

export default __exports__